import { useCallback, useMemo } from "react";

import { useFiltersScope } from "~/components/filters/FiltersScope";
import type { IRangeValue } from "~/types/range";

export const useProbabilityFilter = () => {
  const { filters, updateFilters } = useFiltersScope();

  const initialValue = useMemo(
    () => ({
      min: filters.minChance,
      max: filters.maxChance,
    }),
    [filters.maxChance, filters.minChance]
  );

  const onChangeProbabilityFilter = useCallback(
    (value?: IRangeValue) => {
      updateFilters({ minChance: value?.min, maxChance: value?.max });
    },
    [updateFilters]
  );

  return { onChangeProbabilityFilter, initialValue };
};
